import React from "react";
import Login from "../../../assets/images/login.png";

const AppTr = () => {
    return(
        <div className="container">
            <div className="row">
                <h1>Aplicativo GigaWifiManager</h1>
                <div className="col-sm-12 col-md-5">
                <img src={Login} alt="foto" />
                </div>
                <div className="col-sm-12 col-md-7">
                <span>
                Esse aplicativo oferece a praticidade de configurar os parâmetros dos roteadores, como o nome da rede, 
                senha do Wi-Fi e canais. Além disso, o cliente poderá realizar essas alterações remotamente, 
                basta estar conectado à internet. 
                Aproveite toda a conveniência de gerenciar sua rede de forma fácil e rápida com o nosso aplicativo.
                </span>
                <hr />
                <span>
                Além disso, o cliente terá acesso a informações importantes, como a quantidade de dispositivos 
                conectados à rede, o consumo de banda e o tempo de conexão. Esses dados permitem um melhor controle 
                e monitoramento do uso da internet, proporcionando uma experiência mais eficiente e adequada às 
                necessidades individuais. 
                Tenha todas as informações essenciais ao seu alcance com o nosso aplicativo.
                </span>
                </div>
            </div>
        </div>
    )
}
export default AppTr;